import { render, staticRenderFns } from "./AssemblyManagement.vue?vue&type=template&id=90723d96&scoped=true"
import script from "./AssemblyManagement.vue?vue&type=script&lang=js"
export * from "./AssemblyManagement.vue?vue&type=script&lang=js"
import style0 from "./AssemblyManagement.vue?vue&type=style&index=0&id=90723d96&prod&lang=scss&scoped=true"
import style1 from "./AssemblyManagement.vue?vue&type=style&index=1&id=90723d96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90723d96",
  null
  
)

export default component.exports